export const HOMEPAGE = 'homepage';
export const SEARCH_PAGE = 'search page';
export const ACCOUNT = 'account';
export const EVENT_PAGE = 'event page';
export const EVENTS_LANDING_PAGE = 'events landing page';
export const VENUE_PAGE = 'venue page';
export const LIST_DETAIL = 'list detail page';
export const RESERVATION_DETAILS = 'reservation details';
export const CONFIRMATION = 'confirmation';
export const RESERVATION_PATH = 'reservation path';
export const CHEF_LIST = 'Chef List';
export const GDA_PATH = 'global dining access';
export const GDA_PATH_DIR = 'global dining access directory';
export const GDA_PATH_MEMBER = 'global dining access member';
export const GDA_B2B_PATH = 'global dining access partner page';
export const CAPTCHA = 'captcha';
export const ADD_CARD = 'add card';
export const CENTURION_NY = 'centurion ny events';
export const PLATINUM_NIGHTS = 'platinum nights';
export const RESY_CREDIT = 'resy credit';
export const RESY_CREDIT_AMEX_GOLD = 'resy credit amex gold';
export const RESY_CREDIT_DELTA_RESERVE = 'resy credit delta skymiles reserve';
export const RESY_CREDIT_DELTA_PLATINUM = 'resy credit delta skymiles platinum';
export const RESY_CREDIT_AMEX_PLATINUM = 'resy credit platinum card';
export const RESY_VALUE = 'resy value';
export const RESY_VALUE_CARD_MEMBER = 'welcome card member';
export const EXPERIENCES = 'experiences';
export const DELTA_WIFI = 'delta wifi';
export const SECURITY_CENTER = 'security center';
export const RESY_REWARDS = 'resy rewards';
export const RATINGS = 'ratings';

// home = /
// search = /cities/{code}?date=2021-04-07&seats=2
// account = /account/{section}
// event page = /cities/{locationSlug}/venues/{venue}/events/{event-name}
// events landing page = /cities/{code}/events
// venue = /cities/{locationSlug}/venues/{venue}
// list detail = /account/lists/{listid}
const homepageRegex = /\/$/;
const cityHomepageRegex = /\/cities\/([\w-]+)(\/?)$/;
const searchPageRegex = /\/cities\/[\w-]+\/search$/;
const searchPageListRegex = /\/cities\/[\w-]+\/list\/([\w-]+)$/;
const accountPageRegex = /\/account\/[\w-]+$/;
const eventPageRegex = /\/cities\/([\w-]+)\/venues\/[\w-]+\/events\/[\w-]+$/;
const eventLandingPageRegex = /\/cities\/[\w-]+\/events$/;
const venuePageRegex = /\/cities\/([\w-]+)\/venues\/[\w-]+$/;
const listsPageRegex = /\/account\/lists\/([\w-]+)$/;
const reservationPathRegex = /\/reservation-path-naa$/;
const globalDiningAccessRegex = /\/global-dining-access$/;
const globalDiningAccessDirRegex = /\/global-dining-access\/directory$/;
const globalDiningAccessMemberRegex = /\/global-dining-access-member$/;
const globalDiningAccessB2BRegex = /\/global-dining-access-partner-page$/;
const widgetVenuePageRegex = /\/venues\/[\w-]+$/;
const widgetReservationDetailsRegex = /\/reservation-details$/;
const widgetConfirmationRegex = /\/confirmation$/;
const widgetCaptchaRegex = /\/captcha$/;
const widgetAddCard = /\/add-payment$/;
const widgetCenturionRegex = /\/cnyevents$/;
const platinumNightsSpecialAccessRegex = /\/specialaccess$/;
const platinumNightsPlatinumRegex = /\/platinum$/;
const platinumNightsPlatinumMemberRegex = /\/platinum-member$/;
const platinumNightsAmexPlatinumRegex = /\/amex-platinum$/;
const resyCreditRegex = /\/resycredit$/;
const resyCreditGoldRegex = /\/resycredit\/amexgold$/;
const resyCreditDeltaReserveRegex = /\/resycredit\/deltaskymilesreserve$/;
const resyCreditDeltaPlatinumRegex = /\/resycredit\/deltaskymilesplatinum$/;
const resyCreditAmexPlatinumRegex = /\/resycredit\/platinumcard$/;
const resyValueRegex = /\/welcome$/;
const resyValueRegexCardMember = /\/welcomecardmember$/;
const experiencesRegex = /\/experiences$/;
const deltaWifiRegex = /\/delta$/;
const deltaWifiMarketRegex = /\/delta\/[\w-]+$/;
const securityCenterRegex = /\/security-center$/;
const resyRewardsRegex = /\/resy-rewards$/;
const ratingsPageRegex = /\/rate$/;

const getPageContext = (pathname) => {
  if (homepageRegex.test(pathname) || cityHomepageRegex.test(pathname)) {
    return HOMEPAGE;
  } if (searchPageRegex.test(pathname)) {
    return SEARCH_PAGE;
  } if (searchPageListRegex.test(pathname)) {
    return SEARCH_PAGE;
  } if (listsPageRegex.test(pathname)) {
    return LIST_DETAIL;
  } if (accountPageRegex.test(pathname)) {
    return ACCOUNT;
  } if (eventPageRegex.test(pathname)) {
    return EVENT_PAGE;
  } if (eventLandingPageRegex.test(pathname)) {
    return EVENTS_LANDING_PAGE;
  } if (venuePageRegex.test(pathname)) {
    return VENUE_PAGE;
  } if (widgetVenuePageRegex.test(pathname)) {
    return VENUE_PAGE;
  } if (widgetReservationDetailsRegex.test(pathname)) {
    return RESERVATION_DETAILS;
  } if (reservationPathRegex.test(pathname)) {
    return RESERVATION_PATH;
  } if (widgetConfirmationRegex.test(pathname)) {
    return CONFIRMATION;
  } if (widgetCaptchaRegex.test(pathname)) {
    return CAPTCHA;
  } if (widgetAddCard.test(pathname)) {
    return ADD_CARD;
  } if (globalDiningAccessRegex.test(pathname)) {
    return GDA_PATH;
  } if (globalDiningAccessDirRegex.test(pathname)) {
    return GDA_PATH_DIR;
  } if (globalDiningAccessMemberRegex.test(pathname)) {
    return GDA_PATH_MEMBER;
  } if (globalDiningAccessB2BRegex.test(pathname)) {
    return GDA_B2B_PATH;
  } if (widgetCenturionRegex.test(pathname)) {
    return CENTURION_NY;
  } if (platinumNightsSpecialAccessRegex.test(pathname)
    || platinumNightsPlatinumRegex.test(pathname)
    || platinumNightsPlatinumMemberRegex.test(pathname)
    || platinumNightsAmexPlatinumRegex.test(pathname)) {
    return PLATINUM_NIGHTS;
  }
  if (resyCreditRegex.test(pathname)) {
    return RESY_CREDIT;
  } if (resyCreditGoldRegex.test(pathname)) {
    return RESY_CREDIT_AMEX_GOLD;
  } if (resyCreditDeltaReserveRegex.test(pathname)) {
    return RESY_CREDIT_DELTA_RESERVE;
  } if (resyCreditDeltaPlatinumRegex.test(pathname)) {
    return RESY_CREDIT_DELTA_PLATINUM;
  } if (resyCreditAmexPlatinumRegex.test(pathname)) {
    return RESY_CREDIT_AMEX_PLATINUM;
  } if (resyValueRegex.test(pathname)) {
    return RESY_VALUE;
  } if (resyValueRegexCardMember.test(pathname)) {
    return RESY_VALUE_CARD_MEMBER;
  } if (experiencesRegex.test(pathname)) {
    return EXPERIENCES;
  } if (deltaWifiMarketRegex.test(pathname)) {
    const pathArr = pathname.split('/');
    let dynamicContext = DELTA_WIFI;
    if (pathArr[2]) {
      dynamicContext = `${DELTA_WIFI} ${pathArr[2]}`;
    }
    return dynamicContext;
  } if (deltaWifiRegex.test(pathname)) {
    return DELTA_WIFI;
  } if (securityCenterRegex.test(pathname)) {
    return SECURITY_CENTER;
  } if (resyRewardsRegex.test(pathname)) {
    return RESY_REWARDS;
  } if (ratingsPageRegex.test(pathname)) {
    return RATINGS;
  }
  return undefined;
};

export const getListDetailContext = (pathname) => (listsPageRegex.test(pathname) ? listsPageRegex.exec(pathname)[1] : null);

export default getPageContext;
